import { useOpenActiveGame } from '@ps/web-poker-active-games';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import type { SliderValues } from '../types';

import useCGGameUrl from './useCGGameUrl';

const useCGHandleRegister = (selectedGames: SliderValues[]) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const tableUrl = useCGGameUrl(selectedGames);
  const { openActiveGame } = useOpenActiveGame({ tableUrl });
  const { modal } = useDispatch<Dispatch>();

  const handleRegisterOpen = useCallback(() => {
    if (!selectedGames) return;

    if (isAuthenticated) {
      openActiveGame();
    } else {
      modal.unshift({ path: '/auth/login' });
    }
  }, [selectedGames, isAuthenticated, modal, openActiveGame]);

  return handleRegisterOpen;
};

export default useCGHandleRegister;
